var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroidPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 982,
    viewBox: "0 0 520 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482 272H487C487.552 272 488 272.448 488 273V333C488 333.552 487.552 334 487 334H482V272Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482 398H487C487.552 398 488 398.448 488 399V534C488 534.552 487.552 535 487 535H482V398Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34,
    width: 448,
    height: 914,
    rx: 53,
    fill: "#222222",
    stroke: "#434343",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 39,
    width: 436,
    height: 904,
    rx: 49,
    fill: "#1F1F1F",
    stroke: "#1B1B1B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 70,
    r: 8,
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 70,
    r: 5,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 72,
    r: 2,
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 63,
    width: 166,
    height: 14,
    rx: 7,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 904,
    width: 166,
    height: 14,
    rx: 7,
    fill: "#282828"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1_10)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 120,
    width: 412,
    height: 732,
    fill: "#18191A"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 119.5,
    width: 413,
    height: 733,
    stroke: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_10",
    x: 0,
    y: 0,
    width: 520,
    height: 982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_10"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_10",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1_10",
    x: 51,
    y: 119,
    width: 414,
    height: 734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 120,
    width: 412,
    height: 732,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidPhone);
export default __webpack_public_path__ + "static/media/android-phone.530fb4ffad9f390be5265e291956e80f.svg";
export { ForwardRef as ReactComponent };